<script setup lang="ts">
import { onMounted, ref } from 'vue';
import mod from "module";

interface Props {
	location: string;
}

const props = defineProps<Props>();
const spxHtmlElement = ref<HTMLElement | null>(null);

onMounted(() => {
	const element = document.getElementById(`SPX_${props.location}`);
	setTimeout(() =>{
		if (element && spxHtmlElement.value) {
			spxHtmlElement.value.appendChild(element);

			if(props.location === "Product"){
				const product = element?.querySelector('.sparxpres_product') ?? null;
				const modalTrigger = element?.querySelector('.sparxpres-modal-open') ?? null;
				const textElement = element?.querySelector('.sparxpres-xprespay-text') ?? null;

				if(modalTrigger !== null){
					modalTrigger.classList.add('sparxpres-d-none');
					modalTrigger.style.display = 'none';
					if(textElement !== null){
						textElement.onclick = function(event){
							event.stopPropagation();
							document.getElementById('sparxpresWebSaleModal').classList.remove('sparxpres-d-none');
						}
						textElement.innerHTML = '<div class="flex flex-col align-center"><span class="border-b text-xs">Delbetaling</span><span>Læs mere</span></div>';
					}
				}
			}



		}
	}, 250)

});
</script>

<template>
	<div ref="spxHtmlElement"></div>
</template>
